<script setup lang="ts">
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import { computed, onMounted, ref, watch } from 'vue'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import MoneyCell from '@/onenetwork/components/datatable/MoneyCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import ThumbCell from '@/onenetwork/components/datatable/ThumbCell.vue'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import AccountAPI from '../constants/account.api.uri.const'
import { formatTableDataReferral } from '../helper/table'
import PhoneCell from '@/onenetwork/components/datatable/PhoneCell.vue'

interface Props {
  account: object | null,
  currentTab?: string,
}

const props = defineProps<Props>()

const loading = ref<boolean>(false)
const pageSize = ref(10)
const page = ref(0)
const dataSource = ref({
  list: [],
  totalPage: 0,
  totalRecords: 0,
})

const handleChangePage = (page: number) => {

}

const handleChangePageSize = (size: number) => {

}

const requestFetchData = async () => {
  try{
    const res = await APIClient.get(AccountAPI.referral.list, {
      params: {
        page: page.value,
        page_size: pageSize.value,
        user_id: props.account?.id,
      }
    });

    const { data } = res.data;
    if (res.data.code === 200) {

      dataSource.value = {
        list: formatTableDataReferral(data.data) || [],
        totalPage: 0,
        totalRecords: 0
      }
    }
  } catch (e) {

  }
}

watch(() => props.currentTab, (newTab) => {
  if (newTab === '2') {
    requestFetchData()
  }
})

onMounted(() => {
  requestFetchData()
})
</script>

<template>
  <data-table
    :loading="loading"
    :tableConfig="{
      canShowHide: false,
      columns: {
        code: { label: 'CODE', component: TextCell, visible: true, class: '', sort: false, config: {} },
        avatar: { label: 'Avatar', component: ThumbCell, visible: true, class: '', sort: false, config: {witdh: '40px', height: '40px', borderRadius: '4px'} },
        full_name: { label: 'Tên đầy đủ', component: TextCell, visible: true, class: '', sort: false, config: {} },
        phone: { label: 'Số điện thoại', component: PhoneCell, visible: true, sort: false, class: '', config: {} },
        email: { label: 'Email', component: TextCell, visible: true, sort: false, config: {} },
        created_at: { label: 'Thời gian giới thiệu', component: DateTimeCell, visible: true, class: '', sort: false, config: {} },
      }
    }"
    :page-size="pageSize"
    :page="page"
    :total-page="dataSource?.totalPage || 0"
    :total-records="dataSource?.totalRecords || 0"
    :data="dataSource?.list || []"
    @page-changed="handleChangePage"
    @pagesize-changed="handleChangePageSize"

  />
</template>

<style scoped>

</style>
